export const GET_LIST_CATALOGS_LOADING = 'catalogos/GET_LIST_CATALOGS_LOADING';
export const GET_LIST_CATALOGS_SUCCESS = 'catalogos/GET_LIST_CATALOGS_SUCCESS';
export const GET_LIST_CATALOGS_FAILURE = 'catalogos/GET_LIST_CATALOGS_FAILURE';
